import React from "react";
import { Card, CardBody, CardHeader } from "@chakra-ui/react";

const CARD_VARIANTS = {
  surface: {
    bg: "surface.card",
    borderColor: "border.default",
    borderWidth: "1px",
    borderRadius: "ui-lg",
  },
  outline: {
    bg: "surface.card",
    borderColor: "border.default",
    borderWidth: "1px",
    borderRadius: "ui-lg",
  },
  subtle: {
    bg: "surface.subtle",
    borderColor: "border.default",
    borderWidth: "1px",
    borderRadius: "ui-lg",
  },
};

export function UiCard({ variant = "surface", ...props }) {
  const styleProps = CARD_VARIANTS[variant] || CARD_VARIANTS.surface;
  return <Card {...styleProps} {...props} />;
}

export function UiCardHeader(props) {
  return <CardHeader pb={2} {...props} />;
}

export function UiCardBody(props) {
  return <CardBody pt={0} {...props} />;
}
